
import React, { ChangeEvent } from 'react';
import PlaceOrderCTA from './PlaceOrderCTA';
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext';

interface FormDataProps {
  formData?: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setPin?: any
}

const Form = ({ formData, setFormData, setPin }: FormDataProps) => {


  const { setAddressToggleData, setAddressToggle } = useShoppingCart();

  //   console.log(formData);

  // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
  //   setFormData({ ...formData, [field]: event.target.value });
  // };
  // const handleInputChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, field: string) => {
  //   setFormData({ ...formData, [field]: event.target.value });
  // };

  // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
  //   setFormData({ ...formData, [field]: event.target.value });
  //   console.log(formData.zip);
  //   if (field === 'zip' && formData.zip.length === 6) {
  //     setPin(formData.zip);
  //   }
  // };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
    let value = event.target.value;
    setFormData((formData: any) => ({ ...formData, [field]: value }));
    // console.log(formData.zip);
    if (field === 'zip') {
    setAddressToggle(false);
    value =value.replace(/[^0-9]/g,'');
    }
    if (field === 'first_name') {
      value = value.replace(/[^a-zA-Z\s]/g, '');
    }
    if(field === 'address'){
      value = value.replace(/[^a-zA-Z0-9,\/\s]/g, '');
    }
    if(field === 'phone'){
      value =value.replace(/[^0-9]/g,'');
    }
    
  };

  

  const isInputFilled = (field: string) => {
    return formData[field] !== '';
  };

  const isPhoneNumberValid = () => {
    return formData.phone.length === 10;
  };

  const isEmailValid = () => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(formData.email);
  };

  const getEmailErrorMessage = () => {
    if (isInputFilled('email') && !isEmailValid()) {
      return 'Invalid email format';
    }
    return '';
  };
  // const stateOptions = ['Delhi', 'Kolkata', 'Mumbai'];


  return (
    <div>
      <div className="sign-up-container">

      <div  hidden className={`inputWrapper ${isInputFilled('address_id') ? "addressExist" : "addressNotExist"}`}>
          <input
            type="text"
            placeholder=""
            value={formData.address_id}
            onChange={(event) => handleInputChange(event, 'address_id')}
          />
          {isInputFilled('address_id') ? <label id="addressExist">Address Id</label> : <label id="addressNotExist">Address Id</label>}
        </div>


        <div className={`inputWrapper ${isInputFilled('first_name') ? "addressExist" : "addressNotExist"}`}>
          <input
            type="text"
            placeholder=""
            value={formData.first_name}
            onChange={(event) => handleInputChange(event, 'first_name')}
          />
          {isInputFilled('first_name') ? <label id="addressExist">Full Name</label> : <label id="addressNotExist">Full Name</label>}
        </div>

        <div className={`inputWrapper ${isInputFilled('email') ? "addressExist" : "addressNotExist"}`}>

          <input
            type="text"
            placeholder=""
            value={formData.email}
            onChange={(event) => handleInputChange(event, 'email')}
          />
          {/* {isInputFilled('email') ? <label id="addressExist">Email</label>: <label id="addressNotExist">Email</label>} */}
          {isInputFilled('email') ? (
            isEmailValid() ? (
              <label id="addressExist">Email</label>
            ) : (
              <>
                <label id="addressExistInvalid">Invalid Email</label>
                {/* <div className="errorMessage">{getEmailErrorMessage()}</div> */}
              </>
            )
          ) : (
            <label id="addressNotExist">Email</label>
          )}
        </div>
        <div className={`inputWrapper ${isInputFilled('phone') ? "addressExist" : "addressNotExist"}`}>


          <input
            type="text"
            placeholder=""
            value={formData.phone}
            onChange={(event) => handleInputChange(event, 'phone')}
            maxLength={10}
          />
          {isInputFilled('phone') ? <label id="addressExist">Phone Number</label> : <label id="addressNotExist">Phone Number</label>}
        </div>
        <div className={`inputWrapper ${isInputFilled('address') ? "addressExist" : "addressNotExist"}`}>

          <input
            type="text"
            placeholder=""
            value={formData.address}
            onChange={(event) => handleInputChange(event, 'address')}
            maxLength={90}
          />
          {isInputFilled('address') ? <label id="addressExist">Address</label> : <label id="addressNotExist">Address</label>}
        </div>
        <div className={`inputWrapper ${isInputFilled('zip') ? "addressExist" : "addressNotExist"}`}>


          <input
            type="text"
            placeholder=""
            value={formData.zip}
            onChange={(event) => handleInputChange(event, 'zip')}
            maxLength={6}
          />
          {isInputFilled('zip') ? <label id="addressExist">Pin Code</label> : <label id="addressNotExist">Pin Code</label>}
        </div>
        <div className={`inputWrapper ${isInputFilled('city') ? "addressExist" : "addressNotExist"}`}>


          {/* <input
            type="text"
            placeholder=""
            value={formData.city}
            onChange={(event) => handleInputChange(event, 'city')}
          /> */}

          <input
            type="text"
            placeholder=""
            value={formData.city}
            onChange={(event) => handleInputChange(event, 'city')}
            readOnly
          />
          {isInputFilled('city') ? <label id="addressExist">City</label> : <label id="addressNotExist">City</label>}
        </div>
        <div className={`inputWrapper ${isInputFilled('province') ? "addressExist" : "addressNotExist"}`}>


          <input
            type="text"
            placeholder=""
            value={formData.province}
            onChange={(event) => handleInputChange(event, 'province')}
            readOnly
          />
          {isInputFilled('province') ? <label id="addressExist">State</label> : <label id="addressNotExist">State</label>}
        </div>

        {/* <div className={`inputWrapper ${isInputFilled('province') ? "addressExist" : "addressNotExist"}`}>
          <select
            value={formData.province}
            onChange={(event) => handleInputChange(event, 'province')}
          >
            <option value="">Select State</option>
            {stateOptions.map((state) => (
              <option key={state} value={state}>{state}</option>
            ))}
          </select>
          {isInputFilled('province') ? <label id="addressExist">State</label> : <label id="addressNotExist">State</label>}
        </div> */}
      </div>

    </div>
  );
};

export default Form;





// import React from 'react'


// interface fromDataProps {
//     formData: any
//     setFormData: any
// }

//     const Form = ({ formData, setFormData }: fromDataProps) => {
//     console.log(formData.name)

//     return (
//         <div>
//             <div className="sign-up-container">

//                 <div  className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="Full Name"
//                         value={formData.name}
//                         onChange={(event) =>
//                             setFormData({ ...formData, name: event.target.value })
//                         }
//                     />
//                 </div>
//                 <div className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="Email..."
//                         value={formData.email}
//                         onChange={(event) =>
//                             setFormData({ ...formData, email: event.target.value })
//                         }
//                     />
//                 </div>

//                 <div className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="Phone Number"
//                         value={formData.phone}
//                         onChange={(event) =>
//                             setFormData({ ...formData, phone : event.target.value })
//                         }
//                     />
//                 </div>
//                 <div className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="Address"
//                         value={formData.address}
//                         onChange={(event) =>
//                             setFormData({ ...formData, address : event.target.value })
//                         }
//                     />
//                 </div>
//                 <div className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="Pin Code"
//                         value={formData.zip}
//                         onChange={(event) =>
//                             setFormData({ ...formData, zip : event.target.value })
//                         }
//                     />
//                 </div>
//                 <div className='inputWrapper'>
//                     <input
//                         type="text"
//                         placeholder="City"
//                         value={formData.city}
//                         onChange={(event) =>
//                             setFormData({ ...formData, city : event.target.value })
//                         }
//                     />
//                 </div>
//                 <div className='inputWrapper'>
//                     <input 
//                         type="text"
//                         placeholder="State"
//                         value={formData.province}
//                         onChange={(event) =>
//                             setFormData({ ...formData, province : event.target.value })
//                         }
//                     />
//                 </div>

//             </div>
//         </div>
//     )
// }
// export default Form